import { configureStore } from "@reduxjs/toolkit";
import patientReducer from "./slices/patientSlice";
import procedureReducer from "./slices/procedureSlice";
import doctorReducer from "./slices/doctorSlice";
import productReducer from "./slices/productSlice";
import supplierReducer from "./slices/supplierSlice";
import accountHeadReducer from "./slices/accountHeadSlice";
import toothReducer from "./slices/toothSlice";
import shadeReducer from "./slices/shadeSlice";
import bankReducer from "./slices/bankSlice";
import cashReducer from "./slices/cashSlice";
import workReducer from "./slices/workSlice";
import appointmentReducer from "./slices/appointmentSlice";
import invoiceReducer from "./slices/invoiceSlice";
import quotationReducer from "./slices/quotationSlice";
import purchaseReducer from "./slices/purchaseSlice";
import stockReducer from "./slices/stockSlice";
import financeReducer from "./slices/financeSlice";
import userReducer from "./slices/userSlice";

// Kept as simple inline reducers so existing template components
// that do state.toggle_header / state.layoutstyledata continue to work
// without changes.
const toggleHeaderReducer = (state = false, action) =>
  action.type === "toggle_header" ? action.payload : state;

const layoutStyleReducer = (state = localStorage.getItem("layoutStyling") || "default", action) =>
  action.type === "Layoutstyle_data" ? action.payload : state;

const store = configureStore({
  reducer: {
    // Layout — selectors across the template read these at root level
    toggle_header: toggleHeaderReducer,
    layoutstyledata: layoutStyleReducer,

    // DCMS feature slices
    patients: patientReducer,
    procedures: procedureReducer,
    doctors: doctorReducer,
    products: productReducer,
    suppliers: supplierReducer,
    accountHeads: accountHeadReducer,
    tooth: toothReducer,
    shade: shadeReducer,
    bank: bankReducer,
    cash: cashReducer,
    work: workReducer,
    appointments: appointmentReducer,
    invoices: invoiceReducer,
    quotations: quotationReducer,
    purchases: purchaseReducer,
    stock: stockReducer,
    finance: financeReducer,
    users: userReducer,
  },
});

export default store;
